import { createStore } from 'vuex'

// Modules
import modules from './module_loader'
// Vue.use(Vuex)

export default createStore({
  modules
})
